export default "__VITE_ASSET__CjmQ8M1H__"